import styled from 'styled-components';

export const Container = styled.div`
  margin: 10px 10px;
  max-width: ${(props) => props.maxWidth}px;
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: 100%;
  padding: 10px 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  background: ${(props) => props.theme.simulation.sliderGroupBackgroundColor};
  ${(props) => ({
    border: (props.withBorder ? `1px solid ${props.theme.simulation.sliderGroupBorder}` : '0'),
    height: '248px',
    width: '100%',
  })}
`;

export const Info = styled.div`
  position: absolute;
  bottom: -10px;
  left: calc(50% - 10px);
`;

export const Divisor = styled.div`
  border-right: 1px solid #F5F6FA;
  height: 150px;
  width: 1px;
  margin-top: -25px;
`;
